<template>
    <Tag
        class="tw-select-none"
        :style="{
            'background-color': tag.background,
            color: tag.foreground,
        }"
        :class="{
            'tw-relative tw-block tw-scale-1 hover:tw-scale-105 tw-cursor-pointer tw-transition-all': button,
        }"
    >
        {{ tag.name }}
    </Tag>
</template>
<script setup lang="ts">
import Tag from '@/js/components/Tag.vue';

defineProps({
    tag: {
        type: Object,
        required: true,
    },
    button: {
        type: Boolean,
        default: false,
    },
});
</script>
